// https://spin.atomicobject.com/2017/06/19/strongly-typed-date-string-typescript/

import * as moment from 'moment';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';


export function date2param(date: Date | moment.Moment | string): string {
  const moment_date = moment(date);
  if (!moment_date) {
      return null;
  }
  return moment_date.format('yyyy-MM-DD');
}

export function date2string(date: Date | moment.Moment | string): string {
    const moment_date = moment(date);
    if (!moment_date) {
        return null;
    }
    return moment_date.format('L');
}


export function date2Date(date: Date | moment.Moment | string): Date {
  const moment_date = moment(date);
  if (!moment_date) {
      return null;
  }
  return moment_date.toDate();
}

export function dateToNgbDateStruct(date: Date | string): NgbDateStruct {
    if (!date) {
        return null;
    }

    if (typeof date === 'string') {
        let d = moment(date);

        if (!d.isValid()) {
            console.error("cannot parse date ", date );
            return null;
        }
        date = d.toDate();
    } 

    return {
        year: date.getUTCFullYear(),
        month: date.getUTCMonth() + 1,
        day: date.getUTCDate(),
    };
}

export function ngbDateStructToDate(structD: NgbDateStruct): Date {
    if (!structD) {
        return null;
    }
    return new Date(
        structD.year,
        structD.month - 1,
        structD.day,
    );
}

/*
// Examples

const today = toDateStr(new Date());

const fourthOfJuly = toDateStr('2017-07-04');

fourthOfJuly === '2017-07-04'; // true

function formatDate(date: DateStr) {
  return moment(date).format('MM/DD/YY');
}

formatDate('foo'); // compile error

formatDate(toDateStr('foo')); // runtime error

formatDate(toDateStr('2017-07-04')); // 07/04/17
*/
